// import React, { useEffect, useState } from 'react';
// import './home.css';
// import Sidebar from '../Sidebar/Sidebar';
// import Header from '../Header/Header';
// import { FaUser, FaCog, FaChartLine, FaRegFileAlt } from 'react-icons/fa'; // Import icons from react-icons
// import ganeshlogo from '../images/ganeshlogo.jpeg'
// import axios from 'axios';



// const Home = () => {

//     const [users, setUsers] = useState([]);
 
//     const [todaysBooking, setTodaysBooking] = useState(0);
//     const [todaysAmount, setTodaysAmount] = useState(0);
//     const [todaysBookingCount, setTodaysBookingCount] = useState(0);
//     const [monthlyBookingCount, setMonthlyBookingCount] = useState(0);
//     const [yearlyBookingCount, setYearlyBookingCount] = useState(0);
//     const [todaysPurchase, setTodaysPurchase] = useState(0);
//     const [monthlyPurchase, setMonthlyPurchase] = useState(0);
//     const [yearlyPurchase, setYearlyPurchase] = useState(0);
//     const [totalProducts, setTotalProducts] = useState(0);
    
//     const [loading, setLoading] = useState(true); 
//     const [error, setError] = useState(null); 


//         const fetchTodaysBooking = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/todays-booking');
//               setTodaysBooking(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };

//           const fetchTodaysAmount = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/apicount-todays-booking');
//               setTodaysAmount(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//           const fetchTodaysBookingCount = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/monthly-booking');
//               setTodaysBookingCount(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//           const fetchMonthlyBookingCount = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/yearly-booking');
//               setMonthlyBookingCount(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//           const fetchYearlyBookingCount = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/todays-purchase');
//               setYearlyBookingCount(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//           const fetchTodaysPurchase = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/monthly-purchase');
//               setTodaysPurchase(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//           const fetchMonthlyPurchase = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/yearly-purchase');
//               setMonthlyPurchase(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//           const fetchYearlyPurchase = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/total-products');
//               setYearlyPurchase(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };
//         //   const fetchTotalProducts = async () => {
//         //     try {
//         //       const response = await axios.get('https://posapi.emedha.in/api//monthly-booking');
//         //       setTotalProducts(response.data);  // Set users data from API response
//         //       setLoading(false);         // Stop loading once data is fetched
//         //     } catch (err) {
//         //       setError('Error fetching users');  // Handle errors
//         //       setLoading(false);
//         //     }
//           //};
//           const fetchUsers = async () => {
//             try {
//               const response = await axios.get('https://posapi.emedha.in/api/users');
//               setMonthlyBookingCount(response.data);  // Set users data from API response
//               setLoading(false);         // Stop loading once data is fetched
//             } catch (err) {
//               setError('Error fetching users');  // Handle errors
//               setLoading(false);
//             }
//           };





//     useEffect(() => {
//         fetchTodaysPurchase()
        
//         fetchMonthlyPurchase();
//         fetchYearlyPurchase();
//         //fetchTotalProducts();
//         fetchYearlyBookingCount();
//         fetchTodaysBookingCount();
//         fetchTodaysBooking();
//         fetchTodaysAmount();
//         fetchMonthlyBookingCount();
//         fetchUsers();
//     }, []);




//     console.log(users)

//     return (
//         <>
//             <Sidebar />
//             <div id="main">




//                 {/* <div className="dashboard-container">
//             <div className="card">
//                 <FaUser className="icon"  style={{fontSize:'40px',color:'#4CAF50',marginBottom:'5px'}}/>
//                 <h3 style={{fontSize:'1.2em',margin:'10px 0'}}>Todays Booking</h3>
//                 <p style={{color:'#777',fontSize:'1em',margin:'0'}}>View and manage your profile.</p>
//             </div>
//             <div className="card">
//                 <FaCog className="icon" style={{fontSize:'40px',color:'#4CAF50',marginBottom:'5px'}}/>
//                 <h3 style={{fontSize:'1.2em',margin:'10px 0'}}>Total today's purchase</h3>
//                 <p style={{color:'#777',fontSize:'1em',margin:'0'}}>Customize your preferences.</p>
//             </div>
//             <div className="card">
//                 <FaChartLine className="icon"  style={{fontSize:'40px',color:'#4CAF50',marginBottom:'5px'}}/>
//                 <h3 style={{fontSize:'1.2em',margin:'10px 0'}}>STOCK</h3>
//                 <p style={{color:'#777',fontSize:'1em',margin:'0'}}>View performance metrics.</p>
//             </div>
//             <div className="card">
//                 <FaRegFileAlt className="icon"  style={{fontSize:'40px',color:'#4CAF50',marginBottom:'5px'}}/>
//                 <h3 style={{fontSize:'1.2em',margin:'10px 0'}}>USERS</h3>
//                 <p style={{color:'#777',fontSize:'1em',margin:'0'}}>Generate and view reports.</p>
//             </div>
            
//         </div> */}

//                 <div className="dashboard-container">
//                     <div className="left-cards">
//                         <div className="card">
//                             <FaUser className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>Today's Booking</h3>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL BOOKINGS:</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL AMOUNT RS:</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL BOOKINGS OF THE MONTH:</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL BOOKINGS OF THE YEAR:</p>

//                         </div>
//                         <div className="card">
//                             <FaChartLine className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>STOCK</h3>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>View performance metrics.</p>
//                         </div>

//                     </div>

//                     <div className="image-container">
//                         <img src={ganeshlogo} alt="Dashboard Image" className="dashboard-image" />
//                     </div>

//                     <div className="right-cards">
//                         <div className="card">
//                             <FaCog className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>Total Today's Purchase</h3>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL: </p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}> TOTAL PURCHSES OF THE MONTH:   </p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL PURCHSES OF THE YEAR:    0</p>
//                         </div>

//                         <div className="card">
//                             <FaRegFileAlt className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>USERS</h3>
//                             {users.map((user) => (
//                                 <div key={user.id}>

//                                     {/* Only one p tag to display Name and Role */}
//                                     <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>
//                                         <strong>Name:</strong> {user.username} <strong>Role:</strong> {user.role}
//                                     </p>
//                                 </div>
//                             ))}
//                         </div>


//                     </div>
//                 </div>



//             </div>
//         </>
//     );
// };

// export default Home;




// import React, { useEffect, useState } from 'react';
// import './home.css';
// import Sidebar from '../Sidebar/Sidebar';
// import { FaUser, FaCog, FaChartLine, FaRegFileAlt } from 'react-icons/fa'; // Import icons from react-icons
// import ganeshlogo from '../images/ganeshlogo.jpeg';
// import axios from 'axios';

// const Home = () => {
//     const [users, setUsers] = useState([]);
//     const [todaysBooking, setTodaysBooking] = useState(0);
//     const [todaysAmount, setTodaysAmount] = useState(0);
//     const [todaysBookingCount, setTodaysBookingCount] = useState(0);
//     const [monthlyBookingCount, setMonthlyBookingCount] = useState(0);
//     const [yearlyBookingCount, setYearlyBookingCount] = useState(0);
//     const [todaysPurchase, setTodaysPurchase] = useState(0);
//     const [monthlyPurchase, setMonthlyPurchase] = useState(0);
//     const [yearlyPurchase, setYearlyPurchase] = useState(0);
//     const [totalProducts, setTotalProducts] = useState(0);
    
//     const [loading, setLoading] = useState(true); 
//     const [error, setError] = useState(null); 

//     // API fetch functions
//     const fetchTodaysBooking = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/todays-booking');
//             setTodaysBooking(response.data.total);  // Set total amount for today's bookings
//         } catch (err) {
//             setError('Error fetching today\'s booking');
//         }
//     };

//     const fetchTodaysBookingCount = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/count-todays-booking');
//             setTodaysBookingCount(response.data.t); // Set today's booking count
//         } catch (err) {
//             setError('Error fetching today\'s booking count');
//         }
//     };

//     const fetchMonthlyBookingCount = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/monthly-booking');
//             setMonthlyBookingCount(response.data.tt); // Set total monthly bookings
//         } catch (err) {
//             setError('Error fetching monthly booking count');
//         }
//     };

//     const fetchYearlyBookingCount = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/yearly-booking');
//             setYearlyBookingCount(response.data.ttt); // Set total yearly bookings
//         } catch (err) {
//             setError('Error fetching yearly booking count');
//         }
//     };

//     const fetchTodaysPurchase = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/todays-purchase');
//             setTodaysPurchase(response.data.total); // Set today's total purchases
//         } catch (err) {
//             setError('Error fetching today\'s purchase');
//         }
//     };

//     const fetchMonthlyPurchase = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/monthly-purchase');
//             setMonthlyPurchase(response.data.mp); // Set monthly purchases
//         } catch (err) {
//             setError('Error fetching monthly purchase');
//         }
//     };

//     const fetchYearlyPurchase = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/yearly-purchase');
//             setYearlyPurchase(response.data.yp); // Set yearly purchases
//         } catch (err) {
//             setError('Error fetching yearly purchase');
//         }
//     };

//     const fetchTotalProducts = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/total-products');
//             setTotalProducts(response.data.t); // Set total products
//         } catch (err) {
//             setError('Error fetching total products');
//         }
//     };

//     const fetchUsers = async () => {
//         try {
//             const response = await axios.get('https://posapi.emedha.in/api/users');
//             setUsers(response.data); // Assuming this returns the user data
//         } catch (err) {
//             setError('Error fetching users');
//         }
//     };

//     useEffect(() => {
//         setLoading(true);
//         fetchTodaysBooking();
//         fetchTodaysBookingCount();
//         fetchMonthlyBookingCount();
//         fetchYearlyBookingCount();
//         fetchTodaysPurchase();
//         fetchMonthlyPurchase();
//         fetchYearlyPurchase();
//         fetchTotalProducts();
//         fetchUsers();
//         setLoading(false); // Ensure loading state is stopped after fetching all data
//     }, []);

//     if (loading) return <div>Loading...</div>;
//     if (error) return <div>{error}</div>;

//     return (
//         <>
//             <Sidebar />
//             <div id="main">
//                 <div className="dashboard-container">
//                     <div className="left-cards">
//                         <div className="card">
//                             <FaUser className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>Today's Booking</h3>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL BOOKINGS: {todaysBookingCount}</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL AMOUNT RS: {todaysBooking}</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL BOOKINGS OF THE MONTH: {monthlyBookingCount}</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL BOOKINGS OF THE YEAR: {yearlyBookingCount}</p>
//                         </div>

//                         <div className="card">
//                             <FaChartLine className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>STOCK</h3>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>View performance metrics.</p>
//                         </div>
//                     </div>

//                     <div className="image-container">
//                         <img src={ganeshlogo} alt="Dashboard Image" className="dashboard-image" />
//                     </div>

//                     <div className="right-cards">
//                         <div className="card">
//                             <FaCog className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>Total Today's Purchase</h3>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL: {todaysPurchase}</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL PURCHASES OF THE MONTH: {monthlyPurchase}</p>
//                             <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>TOTAL PURCHASES OF THE YEAR: {yearlyPurchase}</p>
//                         </div>

//                         <div className="card">
//                             <FaRegFileAlt className="icon" style={{ fontSize: '40px', color: '#4CAF50', marginBottom: '5px' }} />
//                             <h3 style={{ fontSize: '1.2em', margin: '10px 0' }}>USERS</h3>
//                             {users.map((user) => (
//                                 <div key={user.id}>
//                                     <p style={{ color: '#777', fontSize: '1em', margin: '0' }}>
//                                         <strong>Name:</strong> {user.username} <strong>Role:</strong> {user.role}
//                                     </p>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Home;



// import React, { useState, useMemo } from "react";
// import Sidebar from "../Sidebar/Sidebar";

// // Self-contained fallback inline SVG icons (replaces external Icons dependency)
// const Icons = {
//   IndianRupee: (size = 20) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M6 3h12M6 8h12M6 13l8.5 8M6 13h3a4.5 4.5 0 0 0 0-9H6" />
//     </svg>
//   ),
//   Ticket: (size = 20) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" />
//       <path d="M13 5v2M13 17v2M13 11v2" />
//     </svg>
//   ),
//   Users: (size = 20) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
//       <circle cx="9" cy="7" r="4" />
//       <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
//     </svg>
//   ),
//   ClipboardList: (size = 20) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
//       <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
//       <path d="M12 11h4M12 16h4M8 11h.01M8 16h.01" />
//     </svg>
//   ),
//   Search: (size = 15) => (
//     <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <circle cx="11" cy="11" r="8" />
//       <path d="m21 21-4.3-4.3" />
//     </svg>
//   ),
// };

// const recentBookings = [
//   { id: 1, customerName: "GiriVantaku", mobileNumber: "9010234339", poojaName: "Sani Pooja", amount: 75, poojaDate: "2026-08-12", status: "Confirmed" },
//   { id: 2, customerName: "SatyaVarma.P", mobileNumber: "8317577756", poojaName: "Abhishekamu", amount: 1516, poojaDate: "2026-08-12", status: "Confirmed" },
//   { id: 3, customerName: "Ramesh", mobileNumber: "9849164361", poojaName: "Homamu (With Samagri)", amount: 3001, poojaDate: "2026-08-12", status: "Pending" },
//   { id: 4, customerName: "test", mobileNumber: "7093686960", poojaName: "Abhishekamu", amount: 301, poojaDate: "2026-08-12", status: "Confirmed" },
//   { id: 5, customerName: "SatyaVarma.P", mobileNumber: "8317577756", poojaName: "Kadambamu (3 Kgs)", amount: 1001, poojaDate: "2026-08-11", status: "Confirmed" },
//   { id: 6, customerName: "GiriVantaku", mobileNumber: "9010234339", poojaName: "Aaku Pooja", amount: 75, poojaDate: "2026-08-11", status: "Completed" },
//   { id: 7, customerName: "SatyaVarma.P", mobileNumber: "8317577756", poojaName: "Sahasranamarchana", amount: 75, poojaDate: "2026-08-11", status: "Completed" },
//   { id: 8, customerName: "test", mobileNumber: "7093686960", poojaName: "Kadambamu (3 Kgs)", amount: 1001, poojaDate: "2026-08-10", status: "Completed" },
// ];

// const statusStyle = {
//   Confirmed: { bg: "#dbeafe", text: "#1e40af" },
//   Pending: { bg: "#fef3c7", text: "#92400e" },
//   Completed: { bg: "#f0fdf4", text: "#15803d" },
//   Cancelled: { bg: "#fef2f2", text: "#dc2626" },
// };

// const upcomingPoojas = [
//   { time: "09:00 AM", pooja: "Rudrabhishek", priest: "Pt. Ramadas" },
//   { time: "11:00 AM", pooja: "Satyanarayan Puja", priest: "Pt. Subramanian" },
//   { time: "02:00 PM", pooja: "Navagraha Homam", priest: "Pt. Ramadas" },
//   { time: "04:30 PM", pooja: "Lakshmi Puja", priest: "Pt. Krishnaswami" },
//   { time: "06:00 PM", pooja: "Evening Aarti", priest: "All Priests" },
// ];

// export default function HomeScreen() {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   const filteredBookings = useMemo(() => {
//     return recentBookings.filter(
//       (b) =>
//         b.customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
//         b.mobileNumber.includes(searchQuery) ||
//         b.poojaName.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//   }, [searchQuery]);

//   const totalPages = Math.ceil(filteredBookings.length / itemsPerPage) || 1;
//   const paginatedBookings = filteredBookings.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const totalRevenue = recentBookings.reduce((s, b) => s + b.amount, 0);
//   const totalBookings = recentBookings.length;
//   const activeCustomers = new Set(recentBookings.map((b) => b.mobileNumber)).size;
//   const pendingCount = recentBookings.filter((b) => b.status === "Pending").length;

//   return (
//     <>
//          <Sidebar />
//     <div
//       style={{
//         display: "flex",
//         flexDirection: "column",
//         gap: "24px",
//         fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//         color: "#111827",
//         maxWidth: "1280px",
//         margin: "0 auto",
//         padding: "16px",
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           alignItems: "center",
//           justifyContent: "space-between",
//           gap: "12px",
//         }}
//       >
//         <div>
//           <h2
//             style={{
//               fontSize: "24px",
//               fontWeight: 700,
//               color: "#111827",
//               margin: 0,
//               fontFamily: "'Cinzel', serif",
//             }}
//           >
//             Dashboard
//           </h2>
//           <p style={{ fontSize: "14px", color: "#6b7280", margin: "2px 0 0 0" }}>
//             Wednesday, 12 August 2026 · Overview of today's activity
//           </p>
//         </div>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//             background: "#ffffff",
//             padding: "8px 12px",
//             borderRadius: "12px",
//             border: "1px solid #ffedd5",
//             fontSize: "14px",
//             boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//           }}
//         >
//           <span style={{ fontSize: "12px", fontWeight: 600, color: "#6b7280" }}>Date</span>
//           <span style={{ fontSize: "12px", fontWeight: 500, color: "#374151" }}>2026-08-12</span>
//         </div>
//       </div>

//       {/* KPI Cards */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
//           gap: "16px",
//         }}
//       >
//         {[
//           { label: "Total Revenue", value: `₹${totalRevenue.toLocaleString()}`, icon: Icons.IndianRupee, color: "#f97316" },
//           { label: "Today's Bookings", value: totalBookings, icon: Icons.Ticket, color: "#d97706" },
//           { label: "Active Devotees", value: activeCustomers, icon: Icons.Users, color: "#16a34a" },
//           { label: "Pending Approvals", value: pendingCount, icon: Icons.ClipboardList, color: "#dc2626" },
//         ].map((k) => (
//           <div
//             key={k.label}
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               border: "1px solid #ffedd5",
//               padding: "20px",
//               display: "flex",
//               gap: "14px",
//               alignItems: "center",
//               boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//             }}
//           >
//             <div
//               style={{
//                 width: "44px",
//                 height: "44px",
//                 borderRadius: "12px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexShrink: 0,
//                 background: `${k.color}18`,
//                 color: k.color,
//               }}
//             >
//               {k.icon(20)}
//             </div>
//             <div>
//               <p style={{ fontSize: "20px", fontWeight: 700, color: "#111827", margin: 0 }}>
//                 {k.value}
//               </p>
//               <p style={{ fontSize: "12px", color: "#6b7280", margin: "2px 0 0 0" }}>
//                 {k.label}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Main Grid */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//           gap: "16px",
//           alignItems: "start",
//         }}
//       >
//         {/* Recent Bookings Table Container */}
//         <div
//           style={{
//             gridColumn: "span 2",
//             background: "#ffffff",
//             borderRadius: "16px",
//             border: "1px solid #ffedd5",
//             overflow: "hidden",
//             boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//           }}
//         >
//           <div
//             style={{
//               padding: "16px 24px",
//               borderBottom: "1px solid #fff7ed",
//               display: "flex",
//               flexDirection: "column",
//               gap: "12px",
//             }}
//           >
//             <div>
//               <h3 style={{ fontWeight: 600, color: "#111827", margin: "0 0 2px 0", fontSize: "16px" }}>
//                 Recent Bookings
//               </h3>
//               <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>
//                 Latest devotee ticket transactions
//               </p>
//             </div>
//           </div>

//           {/* Search */}
//           <div style={{ padding: "12px 24px", borderBottom: "1px solid #fff7ed" }}>
//             <div style={{ position: "relative" }}>
//               <span
//                 style={{
//                   position: "absolute",
//                   left: "14px",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   color: "#9ca3af",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 {Icons.Search(15)}
//               </span>
//               <input
//                 placeholder="Search by Customer Name, Mobile, or Pooja..."
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//                 style={{
//                   width: "100%",
//                   paddingLeft: "40px",
//                   paddingRight: "16px",
//                   paddingTop: "10px",
//                   paddingBottom: "10px",
//                   borderRadius: "12px",
//                   border: "1px solid #e5e7eb",
//                   fontSize: "14px",
//                   outline: "none",
//                   boxSizing: "border-box",
//                   background: "#fdf8f3",
//                   transition: "border-color 0.2s",
//                 }}
//               />
//             </div>
//           </div>

//           {/* Table */}
//           <div style={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", textAlign: "left", borderCollapse: "collapse", fontSize: "14px" }}>
//               <thead>
//                 <tr
//                   style={{
//                     backgroundColor: "rgba(255, 247, 237, 0.6)",
//                     borderBottom: "1px solid #ffedd5",
//                     fontSize: "12px",
//                     fontWeight: 600,
//                     color: "#374151",
//                     textTransform: "uppercase",
//                     letterSpacing: "0.05em",
//                   }}
//                 >
//                   <th style={{ padding: "14px 20px", width: "48px" }}>S.No</th>
//                   <th style={{ padding: "14px 20px" }}>Customer</th>
//                   <th style={{ padding: "14px 20px" }}>Mobile</th>
//                   <th style={{ padding: "14px 20px" }}>Pooja</th>
//                   <th style={{ padding: "14px 20px", textAlign: "right" }}>Amount</th>
//                   <th style={{ padding: "14px 20px" }}>Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedBookings.length > 0 ? (
//                   paginatedBookings.map((b, index) => {
//                     const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;
//                     const ss = statusStyle[b.status] || { bg: "#f3f4f6", text: "#374151" };
//                     return (
//                       <tr
//                         key={b.id}
//                         style={{ borderBottom: "1px solid #fff7ed", transition: "background 0.15s" }}
//                         onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255, 247, 237, 0.4)")}
//                         onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
//                       >
//                         <td style={{ padding: "16px 20px", fontSize: "12px", color: "#6b7280", fontWeight: 500 }}>{serialNumber}</td>
//                         <td style={{ padding: "16px 20px", fontWeight: 600, color: "#111827" }}>{b.customerName}</td>
//                         <td style={{ padding: "16px 20px", fontFamily: "monospace", fontSize: "12px", color: "#4b5563" }}>{b.mobileNumber}</td>
//                         <td style={{ padding: "16px 20px", color: "#374151", fontSize: "12px" }}>{b.poojaName}</td>
//                         <td style={{ padding: "16px 20px", textAlign: "right", fontWeight: 700, color: "#111827" }}>₹{b.amount.toLocaleString()}</td>
//                         <td style={{ padding: "16px 20px" }}>
//                           <span
//                             style={{
//                               padding: "4px 10px",
//                               borderRadius: "9999px",
//                               fontSize: "12px",
//                               fontWeight: 500,
//                               background: ss.bg,
//                               color: ss.text,
//                             }}
//                           >
//                             {b.status}
//                           </span>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={6} style={{ textAlign: "center", padding: "40px 0", color: "#9ca3af", fontSize: "14px" }}>
//                       No bookings found matching your search.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//               {filteredBookings.length > 0 && (
//                 <tfoot>
//                   <tr
//                     style={{
//                       backgroundColor: "rgba(255, 247, 237, 0.8)",
//                       fontWeight: "bold",
//                       borderTop: "1px solid #ffedd5",
//                       fontSize: "14px",
//                     }}
//                   >
//                     <td colSpan={4} style={{ padding: "14px 20px", color: "#374151" }}>Total</td>
//                     <td style={{ padding: "14px 20px", textAlign: "right", color: "#c2410c" }}>
//                       ₹{filteredBookings.reduce((s, b) => s + b.amount, 0).toLocaleString()}
//                     </td>
//                     <td />
//                   </tr>
//                 </tfoot>
//               )}
//             </table>
//           </div>

//           {/* Pagination */}
//           {totalPages > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 padding: "16px",
//                 borderTop: "1px solid #fff7ed",
//               }}
//             >
//               <p style={{ fontSize: "12px", color: "#6b7280", margin: 0 }}>
//                 Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, filteredBookings.length)} of {filteredBookings.length} entries
//               </p>
//               <div style={{ display: "flex", gap: "6px" }}>
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                   disabled={currentPage === 1}
//                   style={{
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: 500,
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                     opacity: currentPage === 1 ? 0.4 : 1,
//                   }}
//                 >
//                   Previous
//                 </button>
//                 {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//                   <button
//                     key={page}
//                     onClick={() => setCurrentPage(page)}
//                     style={{
//                       width: "32px",
//                       height: "32px",
//                       borderRadius: "8px",
//                       fontSize: "12px",
//                       fontWeight: 500,
//                       cursor: "pointer",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       ...(currentPage === page
//                         ? {
//                             background: "#f97316",
//                             color: "#ffffff",
//                             border: "none",
//                             boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//                           }
//                         : {
//                             border: "1px solid #e5e7eb",
//                             color: "#4b5563",
//                             background: "#ffffff",
//                           }),
//                     }}
//                   >
//                     {page}
//                   </button>
//                 ))}
//                 <button
//                   onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//                   disabled={currentPage === totalPages}
//                   style={{
//                     padding: "6px 12px",
//                     borderRadius: "8px",
//                     border: "1px solid #e5e7eb",
//                     fontSize: "12px",
//                     fontWeight: 500,
//                     color: "#4b5563",
//                     backgroundColor: "#ffffff",
//                     cursor: currentPage === totalPages ? "not-allowed" : "pointer",
//                     opacity: currentPage === totalPages ? 0.4 : 1,
//                   }}
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Right Column */}
//         <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
//           {/* Today's Schedule */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               border: "1px solid #ffedd5",
//               padding: "20px",
//               boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//             }}
//           >
//             <h3 style={{ fontWeight: 600, color: "#111827", margin: "0 0 4px 0", fontSize: "16px" }}>
//               Today's Schedule
//             </h3>
//             <p style={{ fontSize: "12px", color: "#9ca3af", margin: "0 0 16px 0" }}>
//               Upcoming poojas for Aug 12
//             </p>
//             <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//               {upcomingPoojas.map((e, i) => (
//                 <div
//                   key={i}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "12px",
//                     padding: "10px",
//                     borderRadius: "12px",
//                     background: "#fdf8f3",
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontFamily: "monospace",
//                       fontSize: "12px",
//                       fontWeight: 700,
//                       color: "#ea580c",
//                       width: "64px",
//                       flexShrink: 0,
//                     }}
//                   >
//                     {e.time}
//                   </span>
//                   <div style={{ minWidth: 0 }}>
//                     <p style={{ fontSize: "12px", fontWeight: 600, color: "#111827", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                       {e.pooja}
//                     </p>
//                     <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                       {e.priest}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Quick Summary */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               border: "1px solid #ffedd5",
//               padding: "20px",
//               boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
//             }}
//           >
//             <h3 style={{ fontWeight: 600, color: "#111827", margin: "0 0 16px 0", fontSize: "16px" }}>
//               Today's Summary
//             </h3>
//             <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
//               {[
//                 { label: "Confirmed", count: recentBookings.filter((b) => b.status === "Confirmed").length, color: "#1e40af", bg: "#dbeafe" },
//                 { label: "Pending", count: recentBookings.filter((b) => b.status === "Pending").length, color: "#92400e", bg: "#fef3c7" },
//                 { label: "Completed", count: recentBookings.filter((b) => b.status === "Completed").length, color: "#15803d", bg: "#f0fdf4" },
//               ].map((s) => (
//                 <div key={s.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                     <div style={{ width: "10px", height: "10px", borderRadius: "50%", background: s.color }} />
//                     <span style={{ fontSize: "14px", color: "#4b5563" }}>{s.label}</span>
//                   </div>
//                   <span
//                     style={{
//                       fontSize: "14px",
//                       fontWeight: 700,
//                       padding: "2px 10px",
//                       borderRadius: "9999px",
//                       background: s.bg,
//                       color: s.color,
//                     }}
//                   >
//                     {s.count}
//                   </span>
//                 </div>
//               ))}
//               <div
//                 style={{
//                   paddingTop: "8px",
//                   borderTop: "1px solid #fff7ed",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <span style={{ fontSize: "14px", fontWeight: 600, color: "#374151" }}>Total Revenue</span>
//                 <span style={{ fontSize: "14px", fontWeight: 700, color: "#ea580c" }}>
//                   ₹{totalRevenue.toLocaleString()}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//     </>
//   );
// }


import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import ganeshlogo from '../images/ganeshlogo.jpeg';
import axios from 'axios';

// Self-contained SVG Icons matching the application's clean design aesthetic
const Icons = {
  Calendar: (size = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  ),
  TrendingUp: (size = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  ShoppingBag: (size = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <path d="M16 10a4 4 0 0 1-8 0"></path>
    </svg>
  ),
  Users: (size = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Box: (size = 20) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
      <line x1="12" y1="22.08" x2="12" y2="12"></line>
    </svg>
  )
};

const Home = () => {
  const [users, setUsers] = useState([]);
  const [todaysBooking, setTodaysBooking] = useState(0);
  const [todaysBookingCount, setTodaysBookingCount] = useState(0);
  const [monthlyBookingCount, setMonthlyBookingCount] = useState(0);
  const [yearlyBookingCount, setYearlyBookingCount] = useState(0);
  const [todaysPurchase, setTodaysPurchase] = useState(0);
  const [monthlyPurchase, setMonthlyPurchase] = useState(0);
  const [yearlyPurchase, setYearlyPurchase] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 

  // Responsive state
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // API fetch functions
  const fetchTodaysBooking = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/todays-booking');
      setTodaysBooking(response.data.total || 0);
    } catch (err) {
      setError("Error fetching today's booking");
    }
  };

  const fetchTodaysBookingCount = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/count-todays-booking');
      setTodaysBookingCount(response.data.t || 0);
    } catch (err) {
      setError("Error fetching today's booking count");
    }
  };

  const fetchMonthlyBookingCount = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/monthly-booking');
      setMonthlyBookingCount(response.data.tt || 0);
    } catch (err) {
      setError('Error fetching monthly booking count');
    }
  };

  const fetchYearlyBookingCount = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/yearly-booking');
      setYearlyBookingCount(response.data.ttt || 0);
    } catch (err) {
      setError('Error fetching yearly booking count');
    }
  };

  const fetchTodaysPurchase = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/todays-purchase');
      setTodaysPurchase(response.data.total || 0);
    } catch (err) {
      setError("Error fetching today's purchase");
    }
  };

  const fetchMonthlyPurchase = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/monthly-purchase');
      setMonthlyPurchase(response.data.mp || 0);
    } catch (err) {
      setError('Error fetching monthly purchase');
    }
  };

  const fetchYearlyPurchase = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/yearly-purchase');
      setYearlyPurchase(response.data.yp || 0);
    } catch (err) {
      setError('Error fetching yearly purchase');
    }
  };

  const fetchTotalProducts = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/total-products');
      setTotalProducts(response.data.t || 0);
    } catch (err) {
      setError('Error fetching total products');
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://posapi.emedha.in/api/users');
      setUsers(response.data || []);
    } catch (err) {
      setError('Error fetching users');
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      await Promise.allSettled([
        fetchTodaysBooking(),
        fetchTodaysBookingCount(),
        fetchMonthlyBookingCount(),
        fetchYearlyBookingCount(),
        fetchTodaysPurchase(),
        fetchMonthlyPurchase(),
        fetchYearlyPurchase(),
        fetchTotalProducts(),
        fetchUsers()
      ]);
      setLoading(false);
    };

    fetchAllData();
  }, []);

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        id="main"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1360px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
          }}
        >
          {/* Dashboard Header */}
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: isMobile ? '22px' : '26px',
                fontWeight: '700',
                color: '#111827',
                fontFamily: "'Cinzel', serif"
              }}
            >
              Dashboard Overview
            </h2>
            <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
              Welcome back! Here is a summary of bookings, inventory, and purchases.
            </p>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#6b7280', fontSize: '14px' }}>
              Loading dashboard overview...
            </div>
          ) : error ? (
            <div
              style={{
                padding: '16px',
                backgroundColor: '#fef2f2',
                borderRadius: '12px',
                border: '1px solid #fee2e2',
                color: '#dc2626',
                fontSize: '14px'
              }}
            >
              {error}
            </div>
          ) : (
            <>
              {/* Top Highlight Summary Stats */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                  gap: '16px',
                  width: '100%'
                }}
              >
                <div
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    padding: '18px 20px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px'
                  }}
                >
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      backgroundColor: 'rgba(249, 115, 22, 0.12)',
                      color: '#ea580c',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}
                  >
                    {Icons.Calendar(20)}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Today's Revenue</p>
                    <p style={{ margin: '2px 0 0 0', fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                      ₹{Number(todaysBooking || 0).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    padding: '18px 20px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px'
                  }}
                >
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      backgroundColor: 'rgba(22, 163, 74, 0.12)',
                      color: '#16a34a',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}
                  >
                    {Icons.TrendingUp(20)}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Today's Bookings</p>
                    <p style={{ margin: '2px 0 0 0', fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                      {todaysBookingCount}
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    padding: '18px 20px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px'
                  }}
                >
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      backgroundColor: 'rgba(8, 145, 178, 0.12)',
                      color: '#0891b2',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}
                  >
                    {Icons.ShoppingBag(20)}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Today's Purchases</p>
                    <p style={{ margin: '2px 0 0 0', fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                      ₹{Number(todaysPurchase || 0).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    padding: '18px 20px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px'
                  }}
                >
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      backgroundColor: 'rgba(124, 58, 237, 0.12)',
                      color: '#7c3aed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}
                  >
                    {Icons.Box(20)}
                  </div>
                  <div>
                    <p style={{ margin: 0, fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>Total Products</p>
                    <p style={{ margin: '2px 0 0 0', fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                      {totalProducts}
                    </p>
                  </div>
                </div>
              </div>

              {/* Main Dashboard 3-Column Layout */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isMobile ? '1fr' : '1fr 340px 1fr',
                  gap: '20px',
                  alignItems: 'start'
                }}
              >
                {/* Left Column: Bookings & Stock */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {/* Today's Booking Metrics Card */}
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '16px',
                      border: '1px solid #ffedd5',
                      padding: '24px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: '#fff7ed',
                          color: '#ea580c',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {Icons.Calendar(18)}
                      </div>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: '17px',
                          fontWeight: '700',
                          color: '#111827',
                          fontFamily: "'Cinzel', serif"
                        }}
                      >
                        Booking Metrics
                      </h3>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Today's Total Count</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#ea580c' }}>
                          {todaysBookingCount}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Today's Total Amount</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#16a34a' }}>
                          ₹{Number(todaysBooking || 0).toLocaleString()}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Monthly Bookings</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                          {monthlyBookingCount}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Yearly Bookings</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                          {yearlyBookingCount}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Stock Metrics Card */}
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '16px',
                      border: '1px solid #ffedd5',
                      padding: '24px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '12px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: '#fff7ed',
                          color: '#ea580c',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {Icons.Box(18)}
                      </div>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: '17px',
                          fontWeight: '700',
                          color: '#111827',
                          fontFamily: "'Cinzel', serif"
                        }}
                      >
                        Stock & Inventory
                      </h3>
                    </div>

                    <div
                      style={{
                        padding: '14px',
                        backgroundColor: '#fdf8f3',
                        borderRadius: '12px',
                        border: '1px solid #ffedd5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div>
                        <p style={{ margin: 0, fontSize: '12px', color: '#6b7280' }}>Total Registered Products</p>
                        <p style={{ margin: '2px 0 0 0', fontSize: '18px', fontWeight: '700', color: '#111827' }}>
                          {totalProducts} items
                        </p>
                      </div>
                      <span
                        style={{
                          padding: '4px 10px',
                          borderRadius: '9999px',
                          backgroundColor: '#ecfdf5',
                          color: '#16a34a',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}
                      >
                        Active
                      </span>
                    </div>
                  </div>
                </div>

                {/* Center Column: Deity / Emblem Feature Card */}
                <div
                  style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    border: '1px solid #ffedd5',
                    padding: '24px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    gap: '16px'
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      maxWidth: '240px',
                      aspectRatio: '1/1',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      border: '3px solid #ffedd5',
                      boxShadow: '0 4px 16px rgba(249, 115, 22, 0.15)',
                      backgroundColor: '#fff7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <img
                      src={ganeshlogo}
                      alt="Ganesh Logo"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  <div>
                    <h4
                      style={{
                        margin: '4px 0',
                        fontSize: '18px',
                        fontWeight: '700',
                        color: '#111827',
                        fontFamily: "'Cinzel', serif"
                      }}
                    >
                      Temple Seva Portal
                    </h4>
                    <p style={{ margin: 0, fontSize: '13px', color: '#6b7280', lineHeight: 1.5 }}>
                      Sanctuary Management, Devotee Booking & Inventory POS
                    </p>
                  </div>
                </div>

                {/* Right Column: Purchases & Users */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {/* Purchase Metrics Card */}
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '16px',
                      border: '1px solid #ffedd5',
                      padding: '24px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '16px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: '#fff7ed',
                          color: '#ea580c',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        {Icons.ShoppingBag(18)}
                      </div>
                      <h3
                        style={{
                          margin: 0,
                          fontSize: '17px',
                          fontWeight: '700',
                          color: '#111827',
                          fontFamily: "'Cinzel', serif"
                        }}
                      >
                        Purchase Summary
                      </h3>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Today's Total</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#ea580c' }}>
                          ₹{Number(todaysPurchase || 0).toLocaleString()}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Month's Total</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                          ₹{Number(monthlyPurchase || 0).toLocaleString()}
                        </span>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px 14px',
                          backgroundColor: '#fdf8f3',
                          borderRadius: '12px',
                          border: '1px solid #ffedd5'
                        }}
                      >
                        <span style={{ fontSize: '13px', color: '#6b7280' }}>Year's Total</span>
                        <span style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>
                          ₹{Number(yearlyPurchase || 0).toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Registered Users Card */}
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '16px',
                      border: '1px solid #ffedd5',
                      padding: '24px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '14px'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '10px',
                            backgroundColor: '#fff7ed',
                            color: '#ea580c',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {Icons.Users(18)}
                        </div>
                        <h3
                          style={{
                            margin: 0,
                            fontSize: '17px',
                            fontWeight: '700',
                            color: '#111827',
                            fontFamily: "'Cinzel', serif"
                          }}
                        >
                          Users
                        </h3>
                      </div>
                      <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '600' }}>
                        {users.length} active
                      </span>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        maxHeight: '160px',
                        overflowY: 'auto'
                      }}
                    >
                      {users.length > 0 ? (
                        users.map((user, index) => (
                          <div
                            key={user.id || user.user_id || index}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '8px 12px',
                              backgroundColor: '#fdf8f3',
                              borderRadius: '10px',
                              border: '1px solid #ffedd5'
                            }}
                          >
                            <span style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>
                              {user.username}
                            </span>
                            <span
                              style={{
                                fontSize: '11px',
                                fontWeight: '600',
                                padding: '3px 8px',
                                borderRadius: '9999px',
                                backgroundColor: user.role === 'Admin' ? '#fef3c7' : '#dbeafe',
                                color: user.role === 'Admin' ? '#92400e' : '#1e40af'
                              }}
                            >
                              {user.role}
                            </span>
                          </div>
                        ))
                      ) : (
                        <p style={{ margin: 0, fontSize: '13px', color: '#9ca3af' }}>No users found.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const Home = () => {
//   // State for today's bookings, purchases, and stock
//   const [todayBooking, setTodayBooking] = useState({});
//   const [monthlyBooking, setMonthlyBooking] = useState({});
//   const [yearlyBooking, setYearlyBooking] = useState({});
//   const [todayPurchase, setTodayPurchase] = useState({});
//   const [monthlyPurchase, setMonthlyPurchase] = useState({});
//   const [yearlyPurchase, setYearlyPurchase] = useState({});
//   const [users, setUsers] = useState([]);

//   // Fetch data on component mount
//   useEffect(() => {
//     // API calls to get data
//     axios.get('http://localhost:3000/api/getTodayBooking').then((response) => setTodayBooking(response.data));
//     axios.get('http://localhost:3000/api/getMonthlyBooking').then((response) => setMonthlyBooking(response.data));
//     axios.get('http://localhost:3000/api/getYearlyBooking').then((response) => setYearlyBooking(response.data));
//     axios.get('http://localhost:3000/api/getTodayPurchase').then((response) => setTodayPurchase(response.data));
//     axios.get('http://localhost:3000/api/getMonthlyPurchase').then((response) => setMonthlyPurchase(response.data));
//     axios.get('http://localhost:3000/api/getYearlyPurchase').then((response) => setYearlyPurchase(response.data));
//     axios.get('/api/getUsers').then((response) => setUsers(response.data));
//   }, []);

//   return (
//     <div className="content-wrapper">
//       <section className="content container-fluid">
//         <div className="row">
//           {/* Today Booking Info */}
//           <div className="col-md-3 col-sm-6 col-xs-12">
//             <div className="info-box">
//               <span className="info-box-icon bg-aqua">
//                 <i className="fa fa-archive"></i>
//               </span>
//               <div className="info-box-content">
//                 <span className="info-box-text">Today's Booking</span>
//                 <span className="info-box-number">
//                   <small>Total Bookings: {todayBooking.totalBookings}</small>
//                 </span>
//                 <span className="info-box-number">
//                   <small>Total Amount: Rs {todayBooking.totalAmount}</small>
//                 </span>
//                 <span className="info-box-number">
//                   <small>Bookings This Month: {monthlyBooking.totalBookings}</small>
//                 </span>
//                 <span className="info-box-number">
//                   <small>Bookings This Year: {yearlyBooking.totalBookings}</small>
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Today's Purchase Info */}
//           <div className="col-md-3 col-sm-6 col-xs-12">
//             <div className="info-box">
//               <span className="info-box-icon bg-aqua">
//                 <i className="fa fa-money"></i>
//               </span>
//               <div className="info-box-content">
//                 <span className="info-box-text">Today's Purchases</span>
//                 <span className="info-box-number">
//                   <small>Total Purchases: {todayPurchase.total}</small>
//                 </span>
//                 <span className="info-box-number">
//                   <small>Purchases This Month: {monthlyPurchase.total}</small>
//                 </span>
//                 <span className="info-box-number">
//                   <small>Purchases This Year: {yearlyPurchase.total}</small>
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Users Info */}
//           <div className="col-md-3 col-sm-6 col-xs-12">
//             <div className="info-box">
//               <span className="info-box-icon bg-aqua">
//                 <i className="fa fa-users"></i>
//               </span>
//               <div className="info-box-content">
//                 <span className="info-box-text">Users</span>
//                 {users.map((user) => (
//                   <span key={user.id} className="info-box-number">
//                     <small>{user.username} - {user.role}</small>
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;
